import React from 'react';
import { Paper, Box, Typography, Grid } from '@material-ui/core';
import HeadCardStyled from './headCardStyles';

export default ({ data, list }) => {
  return (
    <HeadCardStyled>
      <Paper sx={{ padding: '16px 24px 31px', borderRadius: '4px' }}>
        <Grid container spacing={2} sx={{ gap: '34px 0' }}>
          {list.map((item, index) => (
            <Grid item xs={2.4} key={`vip${index}`} sx={{ paddingTop: 0 }}>
              <Box display="flex" flexDirection="column">
                <Typography className="detail-label">{item.label}</Typography>
                <Typography className="detail-info">
                  {data
                    ? item.render
                      ? item.render(data[item.id])
                      : data[item.id]
                    : ''}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </HeadCardStyled>
  );
};
